import { fmtPrice } from '../utils/format';

export default function AlertBanner({ notifications, onDismiss }) {
  if (!notifications.length) return null;
  return (
    <div className="alert-banners-wrap">
      {notifications.map(n => (
        <div key={n.notifId} className="alert-banner">
          <span className="banner-bell">🔔</span>
          <div className="banner-body">
            <strong>{n.coinSymbol.toUpperCase()}</strong> elérte a riasztási szintet — az ár
            {n.direction === 'above' ? ' felette van: ' : ' alatta van: '}{fmtPrice(n.price)}
          </div>
          <button className="banner-close" onClick={() => onDismiss(n.notifId)}>×</button>
        </div>
      ))}
    </div>
  );
}
